/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};

// Flickity arrow shape - scaled for 100x100 viewBox
const arrowShape = 'M 60,95 C 63.5,91.5 63.5,85.5 60,82 L 30,52 60,22 C 63.5,18.5 63.5,12.5 60,9 56.5,5.5 50.5,5.5 47,9 L 12,44 C 10,46 9,48.5 9,51 9,53.5 10,56 12,58 L 47,93 C 50.5,96.5 56.5,96.5 60,95 Z';

Shopify.theme.jsStudioPlusCarousel = {
  init: function($section) {
    // Add settings from schema to current object
    Shopify.theme.jsStudioPlusCarousel = $.extend(this, Shopify.theme.getSectionData($section));
    
    // Selectors
    const $carouselEl = $section.find('[data-studio-plus-carousel]');
    const sectionId = $carouselEl.data('section-id');
    
    console.log('Studio+ Carousel Init:', {
      carouselFound: $carouselEl.length,
      slideCount: this.slide_count,
      sectionId: sectionId
    });
    
    // Only initialize if there are slides
    if (this.slide_count === 0) {
      console.warn('Studio+ Carousel: No slides found');
      return;
    }

    // Initialize Flickity carousel
    const $carousel = $carouselEl.flickity({
      wrapAround: false,
      adaptiveHeight: false,
      prevNextButtons: this.slide_count > 1 ? this.show_arrows : false,
      pageDots: this.slide_count > 1 ? this.show_dots : false,
      draggable: this.slide_count > 1,
      imagesLoaded: true,
      cellAlign: 'center',  // Center slides on screen
      contain: false,
      autoPlay: this.autoplay ? this.autoplay_speed * 1000 : false,
      arrowShape: arrowShape,
      friction: 0.5,  // Increased from default 0.28 for snappier feel
      selectedAttraction: 0.06  // Increased from default 0.025 for faster snap-to-position
    });

    console.log('Studio+ Carousel: Flickity initialized successfully');

    // Resize flickity when the slider is settled
    $carouselEl.on('settle.flickity', function() {
      $carouselEl.flickity('resize');
    });

    // Handle expand button clicks
    this.initOverlay($section);
  },

  initOverlay: function($section) {
    const $overlay = $('[data-studio-plus-carousel-overlay]');
    const $overlayContent = $overlay.find('[data-overlay-content]');
    const $closeBtn = $overlay.find('[data-close-overlay]');

    // Expand button and image click handler - make entire image clickable
    $section.on('click', '.studio-plus-carousel__slide-image', function(e) {
      e.preventDefault();
      const $slide = $(this).closest('.studio-plus-carousel__slide');
      const slideIndex = $slide.index();
      const $overlayData = $slide.find('[data-overlay-data]');
      
      // Build overlay content from data
      let overlayHTML = '';
      
      // Title
      const title = $overlayData.find('[data-overlay-title]').text();
      if (title) {
        overlayHTML += '<h2 class="studio-plus-overlay__title">' + title + '</h2>';
      }
      
      // Sections container
      overlayHTML += '<div class="studio-plus-overlay__sections">';
      
      // Loop through sections
      $overlayData.find('[data-overlay-section]').each(function() {
        overlayHTML += '<div class="studio-plus-overlay__section">';
        
        // Image
        const $image = $(this).find('[data-overlay-section-image]');
        if ($image.length) {
          overlayHTML += '<div class="studio-plus-overlay__section-image">' + $image.html() + '</div>';
        }
        
        // Text content
        overlayHTML += '<div class="studio-plus-overlay__section-text">';
        
        // Heading
        const heading = $(this).find('[data-overlay-section-heading]').text();
        if (heading) {
          overlayHTML += '<h3 class="studio-plus-overlay__section-heading">' + heading + '</h3>';
        }
        
        // Subheading
        const subheading = $(this).find('[data-overlay-section-subheading]').text();
        if (subheading) {
          overlayHTML += '<h4 class="studio-plus-overlay__section-subheading">' + subheading + '</h4>';
        }
        
        // Body text
        const text = $(this).find('[data-overlay-section-text]').html();
        if (text) {
          overlayHTML += '<div class="studio-plus-overlay__section-body">' + text + '</div>';
        }
        
        overlayHTML += '</div>'; // Close section-text
        overlayHTML += '</div>'; // Close section
      });
      
      overlayHTML += '</div>'; // Close sections container
      
      // Button
      const buttonLabel = $overlayData.find('[data-overlay-button-label]').text();
      const buttonUrl = $overlayData.find('[data-overlay-button-url]').text();
      if (buttonLabel && buttonUrl) {
        overlayHTML += '<div class="studio-plus-overlay__button-wrapper">';
        overlayHTML += '<a href="' + buttonUrl + '" class="studio-plus-shop-button studio-plus-shop-button--modal-desktop">' + buttonLabel + '</a>';
        overlayHTML += '</div>';
      }
      
      // Add content to overlay
      $overlayContent.html(overlayHTML);
      
      // Show overlay
      $overlay.addClass('is-active');
      $('body').addClass('studio-plus-carousel-overlay-open');
      
      // Prevent body scroll
      $('body').css('overflow', 'hidden');
      
      // Prevent scroll events on background
      Shopify.theme.jsStudioPlusCarousel.preventBackgroundScroll();
    });

    // Close button click handler
    $closeBtn.on('click', function(e) {
      e.preventDefault();
      Shopify.theme.jsStudioPlusCarousel.closeOverlay();
    });

    // Close on overlay background click
    $overlay.on('click', function(e) {
      if ($(e.target).is('[data-studio-plus-carousel-overlay]')) {
        Shopify.theme.jsStudioPlusCarousel.closeOverlay();
      }
    });

    // Close on ESC key
    $(document).on('keydown.studioPlusCarousel', function(e) {
      if (e.key === 'Escape' && $overlay.hasClass('is-active')) {
        Shopify.theme.jsStudioPlusCarousel.closeOverlay();
      }
    });
  },

  closeOverlay: function() {
    const $overlay = $('[data-studio-plus-carousel-overlay]');
    const $overlayContent = $overlay.find('[data-overlay-content]');
    
    $overlay.removeClass('is-active');
    $('body').removeClass('studio-plus-carousel-overlay-open');
    $('body').css('overflow', '');
    
    // Re-enable background scroll
    Shopify.theme.jsStudioPlusCarousel.enableBackgroundScroll();
    
    // Clear overlay content after animation
    setTimeout(function() {
      $overlayContent.html('');
    }, 300);
  },

  preventBackgroundScroll: function() {
    this.scrollHandler = function(e) {
      const modalContent = document.querySelector('[data-overlay-content]');
      let target = e.target;
      
      // Check if the scroll is happening on or inside the modal content
      let isInsideModal = false;
      let scrollableElement = null;
      
      while (target) {
        if (target === modalContent) {
          isInsideModal = true;
          scrollableElement = modalContent;
          break;
        }
        target = target.parentElement;
      }
      
      // If NOT inside modal, prevent scroll completely
      if (!isInsideModal) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      
      // Inside modal - check if we're at scroll boundaries to prevent scroll chaining
      if (scrollableElement && e.deltaY) {
        const scrollTop = scrollableElement.scrollTop;
        const scrollHeight = scrollableElement.scrollHeight;
        const clientHeight = scrollableElement.clientHeight;
        const deltaY = e.deltaY;
        
        // Add a small buffer (1px) to account for rounding errors
        const isAtTop = scrollTop <= 1;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
        
        // Scrolling up at the top
        if (deltaY < 0 && isAtTop) {
          e.preventDefault();
          e.stopPropagation();
          scrollableElement.scrollTop = 0; // Lock to top
          return;
        }
        
        // Scrolling down at the bottom
        if (deltaY > 0 && isAtBottom) {
          e.preventDefault();
          e.stopPropagation();
          scrollableElement.scrollTop = scrollHeight - clientHeight; // Lock to bottom
          return;
        }
      }
    };
    
    // Use native event listeners with passive: false on document
    document.addEventListener('wheel', this.scrollHandler, { passive: false, capture: true });
    document.addEventListener('touchmove', this.scrollHandler, { passive: false, capture: true });
  },

  enableBackgroundScroll: function() {
    // Remove scroll prevention
    if (this.scrollHandler) {
      document.removeEventListener('wheel', this.scrollHandler, { passive: false, capture: true });
      document.removeEventListener('touchmove', this.scrollHandler, { passive: false, capture: true });
    }
  },

  blockSelect: function($section, blockId) {
    const $carousel = $section.find('[data-studio-plus-carousel]');
    const $slide = $('#shopify-section-' + blockId);
    const slideIndex = $slide.index();
    
    if ($carousel.data('flickity')) {
      $carousel.flickity('select', slideIndex, false, true);
    }
  },

  unload: function($section) {
    const $carouselEl = $section.find('[data-studio-plus-carousel]');
    
    // Destroy Flickity instance
    if ($carouselEl.data('flickity')) {
      $carouselEl.flickity('destroy');
    }
    
    // Remove event listeners
    $(document).off('keydown.studioPlusCarousel');
    this.enableBackgroundScroll();
    $section.off('click', '.studio-plus-carousel__slide-image');
  }
};

/******/ })();

